import { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import ErrorDisplay from "./ErrorDisplay";

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: ${props => props.hasError ? '1.5rem' : '0'};
  border-radius: ${props => props.hasError ? '0.5rem' : '0'};
  border: ${props => props.hasError ? `2px solid ${props.theme.errorBorder}` : 'none'};
  background-color: ${props => props.hasError ? props.theme.errorBg : 'transparent'};
  margin-bottom: 1.5rem;
`;

const ModernQuestionHeader = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${props => props.theme.textPrimary};
  margin: 0;
  
  @media (min-width: 768px) {
    font-size: 1.875rem;
  }
`;

const AnswerOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const MultipleLabel = ({
  currentPageAnswers,
  question,
  answeredQuestions,
  setAnsweredQuestions,
  setCurrentPageAnswers,
  currentPage,
  errors,
  setErrors,
  parseDynamicQuestionText,
  showQuestion
}) => {
  // State for which checkboxes are checked
  const [checkedStates, setCheckedStates] = useState(question.Answers.map((answer) =>
    answeredQuestions[currentPage - 1]?.includes(answer.Expression)
      ? true
      : false
  ));
  const [otherText, setOtherText] = useState(
    answeredQuestions[currentPage - 1]?.find((answer) => answer?.includes("_o"))
      ? answeredQuestions[currentPage - 1]?.find((answer) =>
          answer?.includes("_o")
        ) !== "null" || answeredQuestions[currentPage - 1]?.find((answer) =>
          answer?.includes("_o")
        ) !== "-998" ? answeredQuestions[currentPage - 1]?.find((answer) =>
          answer?.includes("_o")
        )
        : ""
      : ""
  );
  const textInputRef = useRef(null);

                    

  useEffect(() => {
    if (
      textInputRef.current &&
      answeredQuestions[currentPage - 1]?.includes(
        textInputRef.current.dataset.code
      )
    ) {
      textInputRef.current.focus();
    }

       
  }, [answeredQuestions]);

  useEffect(() => {
    let answeredQuestionsCopy = [...answeredQuestions]
    if (answeredQuestions[currentPage - 1]?.length) {
      setCheckedStates(question.Answers.map((answer) =>
        answeredQuestions[currentPage - 1]?.includes(answer.Expression)
          ? true
          : false
      ))

     if (answeredQuestionsCopy[currentPage - 1].some(ans => ans.includes('_o='))) {
      answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[currentPage - 1].map(ans => ans.includes('_o=') ? ans.includes('=null') ? ans.replace('=null', '=-998') : ans : ans)
     } else {
      
      let otherExpressionsArray = question.Answers.filter(ansObj => ansObj.AnswerType === 'Other' || ansObj.AnswerType === 'Email' || ansObj.AnswerType === 'Numeric' || ansObj.AnswerType === 'FloatingPoint').map(ansObj => ansObj.Expression)

      otherExpressionsArray.forEach(expression => answeredQuestionsCopy[currentPage - 1].push(`${expression.split('=')[0]}_o=-998`))
     }

     setAnsweredQuestions(answeredQuestionsCopy);
    //debugger
     setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);

    } else {
      answeredQuestionsCopy[currentPage - 1] = question.Answers.map(
        (answer, i) => `${answer.Expression.split("=")[0]}=${showQuestion(answer.showIf) ? '0' : ''}`
      );

      let otherExpressionsArray = question.Answers.filter(ansObj => ansObj.AnswerType === 'Other' || ansObj.AnswerType === 'Email' || ansObj.AnswerType === 'Numeric' || ansObj.AnswerType === 'FloatingPoint').map(ansObj => ansObj.Expression)

      otherExpressionsArray.forEach(expression => answeredQuestionsCopy[currentPage - 1].push(`${expression.split('=')[0]}_o=-998`))

      setAnsweredQuestions(answeredQuestionsCopy);
     //debugger
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);

      setCheckedStates(question.Answers.map((answer) =>
        false
      ))
    }
  }, [currentPage])

  const handleCheckboxChange = (i) => {
    const updatedCheckedStates = [...checkedStates];
    const answerType = question.Answers[i].AnswerType;
    let answeredQuestionsCopy = [...answeredQuestions];
    if (answerType === "None") {
      // If "None" is checked, uncheck all other answers

      const newState = question.Answers.map((answer, index) => index === i);

      answeredQuestionsCopy[currentPage - 1] = question.Answers.map(
        (answer, i) =>
          `${answer.Expression.split("=")[0]}=${newState[i] ? "1" : "0"}`
      );

      let otherExpressionsArray = question.Answers.filter(ansObj => ansObj.AnswerType === 'Other' || ansObj.AnswerType === 'Email' || ansObj.AnswerType === 'Numeric' || ansObj.AnswerType === 'FloatingPoint').map(ansObj => ansObj.Expression)

      otherExpressionsArray.forEach(expression => answeredQuestionsCopy[currentPage - 1].push(`${expression.split('=')[0]}_o=-998`))
            
      setAnsweredQuestions(answeredQuestionsCopy);
     //debugger
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
      setCheckedStates(newState);
    } else {
      // If a "Normal" answer is checked, uncheck all "None" answers
      updatedCheckedStates[i] = !updatedCheckedStates[i];

      // Find all indexes of "None" type answers
      const noneIndexes = question.Answers.reduce((indexes, answer, index) => {
        if (answer.AnswerType === "None") {
          indexes.push(index);
        }
        return indexes;
      }, []);

      // Uncheck all "None" type answers
      noneIndexes.forEach(noneIndex => {
        updatedCheckedStates[noneIndex] = false;
      });

                

      answeredQuestionsCopy[currentPage - 1] = [
        ...question.Answers.map(
          (answer, i) =>
            `${answer.Expression.split("=")[0]}=${
              updatedCheckedStates[i] ? "1" : "0"
            }`
        ),
        currentPageAnswers.length > question.Answers.length
          ? currentPageAnswers[currentPageAnswers.length - 1]
          : question.Answers.filter(answerObj => (answerObj.AnswerType === "Email" ||
            answerObj.AnswerType === "Other" ||
            answerObj.AnswerType === "Numeric" ||
            answerObj.AnswerType === "FloatingPoint")).map(ansObj => ansObj ? `${ansObj.Expression.split('=')[0]}_o=-998` : null).filter(ansExpression => ansExpression),
      ];

      if (answerType === "Email" ||
        answerType === "Other" ||
        answerType === "Numeric" ||
        answerType === "FloatingPoint") {
                                   
          if (checkedStates[i]) {
                  
            answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[currentPage - 1].filter(ans => typeof ans === 'string').map(answerExpression => answerExpression.split('=')[0] === `${question.Answers[question.Answers.findIndex(answer => answer.AnswerCode === answeredQuestionsCopy[currentPage - 1][i].split('=')[0])].Expression.split('=')[0]}_o` ? `${answerExpression.split('=')[0]}=-998` : answerExpression)  

            setOtherText('')
          } else {
            if (answeredQuestions[currentPage - 1].find(answerString => answerString.split('=')[0] === `${answeredQuestionsCopy[currentPage - 1][i].split('=')[0]}_o`)?.includes('=-998')) {
              setOtherText('')
            }
          }
      }

                
      
      setAnsweredQuestions(answeredQuestionsCopy);
     //debugger
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);

      setCheckedStates(updatedCheckedStates);
    }
  };

  const handleInputChange = (event, answerExpression) => {
    let newValue = `${answerExpression.split("=")[0]}_o=${event.target.value}`;

    let answeredQuestionsCopy = [...answeredQuestions];

    answeredQuestionsCopy[currentPage - 1] = [
      ...answeredQuestionsCopy[currentPage - 1]?.filter(
        (answer) => !answer?.includes(newValue.split("=")[0])
      ),
      newValue,
    ];

    setAnsweredQuestions(answeredQuestionsCopy);
   //debugger
    setCurrentPageAnswers([
      ...currentPageAnswers.filter(
        (answer) => !answer?.includes(newValue.split("=")[0])
      ),
      newValue,
    ]);

    setOtherText(newValue);

    setErrors(
      errors.filter(
        (errorExpression) =>
          errorExpression !== event.target?.dataset.questioncode
      )
    );
  };

  // Check if there are errors for this question
  const hasError = errors && errors.includes(question.QuestionCode);

  return (
    <QuestionContainer hasError={hasError}>
      <ModernQuestionHeader dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(question.QuestionName, true)}}></ModernQuestionHeader>
      <AnswerOptionsContainer>
        {question.Answers.map((obj, i) => {
         //debugger
          showQuestion(obj.showIf) ? window.shown++ : window.shown = window.shown


          const isChecked = checkedStates[i];
          
          return (
            <CheckBoxLabel shownQuestion={showQuestion(obj.showIf)} key={i} checked={isChecked}>
              <CheckboxWrapper>
                <HiddenCheckbox
                  type="checkbox"
                  id={`check-${i}`}
                  checked={isChecked}
                  onChange={() => handleCheckboxChange(i)}
                />
                <StyledCheckbox checked={isChecked}>
                  {isChecked && (
                    <CheckmarkIcon viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7"/>
                    </CheckmarkIcon>
                  )}
                </StyledCheckbox>
              </CheckboxWrapper>
              <LabelText 
                checked={isChecked}
                dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(obj.AnswerLabel, true)}}
              />
              {(obj.AnswerType === "Email" ||
                obj.AnswerType === "Other" ||
                obj.AnswerType === "Numeric" ||
                obj.AnswerType === "FloatingPoint") && (
                <TextInput
                  type="text"
                  data-code={obj.Expression}
                  data-questioncode={question.QuestionCode}
                  ref={textInputRef}
                  disabled={!isChecked}
                  show={isChecked}
                  value={
                    obj.AnswerType === "Email"
                      ? currentPageAnswers
                          .find((answered) =>
                            answered?.includes(obj.Expression?.split("=")[0])
                          )
                          ?.split("=")[1] !== "null" || currentPageAnswers
                          .find((answered) =>
                            answered?.includes(obj.Expression?.split("=")[0])
                          )
                          ?.split("=")[1] !== "-998" ?
                          currentPageAnswers
                          .find((answered) =>
                            answered?.includes(obj.Expression?.split("=")[0])
                          )
                          ?.split("=")[1] : "" 
                      : (otherText.split("=")[1] !== "null" && otherText.split("=")[1] !== "-998") ? otherText.split("=")[1]
                      : ""  
                  }
                  onChange={(e) => {
                    handleInputChange(e, obj.Expression);
                  }}
                />
              )}
            </CheckBoxLabel> 
          ) 
        })}
      </AnswerOptionsContainer>
      
      <ErrorDisplay errors={errors} questionCode={question.QuestionCode} />
    </QuestionContainer>
  );
};

const CheckBoxLabel = styled.label`
  display: ${props => props.shownQuestion ? 'flex' : 'none'};
  align-items: center;
  gap: 1rem;
  min-height: auto;
  padding: 1rem;
  background-color: ${props => props.checked ? props.theme.selectedBg : props.theme.cardBg};
  border-radius: 0.5rem;
  border: 2px solid ${props => props.checked ? props.theme.selectedBorder : props.theme.borderPrimary};
  cursor: pointer;
  transition: ${props => props.theme.transition};

  &:hover {
    border-color: ${props => props.checked ? props.theme.selectedBorder : props.theme.borderSecondary};
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

const StyledCheckbox = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid ${props => props.checked ? props.theme.selectedBorder : props.theme.borderSecondary};
  border-radius: 4px;
  background-color: ${props => props.checked ? props.theme.selectedBorder : props.theme.inputBg};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ${props => props.theme.transition};
  
  ${CheckBoxLabel}:hover & {
    border-color: ${props => props.theme.selectedBorder};
  }
`;

const CheckmarkIcon = styled.svg`
  width: 16px;
  height: 16px;
  color: white;
`;

const LabelText = styled.span`
  flex: 1;
  font-size: 1rem;
  font-weight: ${props => props.checked ? '600' : '400'};
  color: ${props => props.theme.textPrimary};
`;

const TextInput = styled.input`
  display: ${(props) => (props.show ? "block" : "none")};
  width: 100%;
  margin-top: 0.5rem;
  padding: 0.5rem;
  border: none;
  border-top: 1px solid ${props => props.theme.borderPrimary};
  background-color: inherit;
  color: inherit;
  font-size: inherit;
  font-family: inherit;

  &:focus {
    outline: none;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export default MultipleLabel;
